import { render } from "./Tercero.vue?vue&type=template&id=26a7e7e4"
import script from "./Tercero.vue?vue&type=script&lang=js"
export * from "./Tercero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__